import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Src1 from '../../../assets/images/s2_5_img1.png';
import Src2 from '../../../assets/images/s2_5_img2.png';
import Src3 from '../../../assets/images/s2_5_img3.png';
import Src4 from '../../../assets/images/s2_5_img4.png';
import Src5 from '../../../assets/images/s2_5_img5.png';

import Src6 from '../../../assets/images/s2_5_img6.png';
import Src7 from '../../../assets/images/s2_5_img7.png';
import Src8 from '../../../assets/images/s2_5_img8.png';
import Src9 from '../../../assets/images/s2_5_img9.png';
import Src10 from '../../../assets/images/s2_5_img10.png';

import Src11 from '../../../assets/images/s2_5_img11.png';
import Src12 from '../../../assets/images/s2_5_img12.png';
import Src13 from '../../../assets/images/s2_5_img13.png';
import Src14 from '../../../assets/images/s2_5_img14.png';
import Src15 from '../../../assets/images/s2_5_img15.png';
import Src16 from '../../../assets/images/s2_5_img16.png';

export default function Content() {

  return (
    <>
      <div className="s2_5_content">
        <div className="col-flex flex-center mb-10">
          <img src={Src1} alt="" />
          <img src={Src2} alt="" />
          <img src={Src3} alt="" />
          <img src={Src4} alt="" />
          <img src={Src5} alt="" />
          <img src={Src6} alt="" />
          <img src={Src7} alt="" />
          <img src={Src8} alt="" />
          <img src={Src9} alt="" />
          <img src={Src10} alt="" />
          <img src={Src11} alt="" />
          <img src={Src12} alt="" />
          <img src={Src13} alt="" />
          <img src={Src14} alt="" />
          <img src={Src15} alt="" />
          <img src={Src16} alt="" />
        </div>
     
      </div>


    </>
  );
}
